import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { TipoClienteModel } from 'app/model/cliente/tipocliente.model';
import { Observable } from 'rxjs/Observable';
import { _throw as throwError } from 'rxjs/observable/throw';
import { environment } from 'environments/environment';

@Injectable()
export class TipoclienteService {

  apiURL = environment.API;


  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) {

   }

  getTipoClientes(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-tipocliente?page=${page}&size=${size}`, this.httpOptions);
  }

  getTipoClientes2(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-tipocliente', this.httpOptions);
  }

  deleteTipoCliente(id:any){
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + '/delete/deletar-tipocliente/' + id, {responseType: 'text', headers});
  }

  cadastrarTipoCliente(tipoCliente: TipoClienteModel): Observable<TipoClienteModel> {
    return this.httpClient.post<TipoClienteModel>(this.apiURL + '/new/adicionar-tipocliente', tipoCliente, this.httpOptions)
  }

  atualizarTipoCliente(tipocliente: TipoClienteModel): Observable<TipoClienteModel>{
    return this.httpClient.put<TipoClienteModel>(this.apiURL + '/edit/editar-tipocliente', tipocliente, this.httpOptions)
  }

  handleError(error: HttpErrorResponse){
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
      console.log('errorMessage1if: '+ errorMessage);
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
      console.log('errorMessage2if: '+ errorMessage);
    }
    console.log('errorMessage' + errorMessage);
    return throwError(errorMessage);
  };

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/tipocliente.service.ts